
































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import AppFooter from "@/components/AppFooter.vue";
import DatePicker from "@/components/DatePicker.vue";
import { DebugTerminal, ManagementResponse, ParamsDebugTerminal, User } from "@/domain";
import { queryDisaDebugTerminals, queryManagementData, saveDisaDebugTerminals } from "@/domain/backend";
import { callExportAuditLogins, callExportTransactions, callExportVending } from "@/domain/backend/export";

@Component({
  components: { AppFooter, DatePicker }
})
export default class Error extends Vue {
  error = "";
  dialog = false;
  deleteDialog = false;
  loading = true;
  loadingTerminals = true;
  isEditForm = false;
  managementData: ManagementResponse | null = null;
  debugTerminals: DebugTerminal[] | null = new Array<DebugTerminal>();
  terminalSearch = "";
  savingTerminal = false;
  itemToDelete: DebugTerminal | null = null;
  editedItem = {
    id: "",
    name: "",
    app: ""
  };
  exportLoading = false;
  exportTransaction = {
    companyID: "",
    from: "",
    to: "",
    limit: 1000
  };
  exportUserAudit = {
    uid: "",
    from: "",
    to: "",
    limit: 1000
  };
  exportVending = {
    tcod: ""
  };

  get lang() {
    return this.$store.state.lang.data;
  }

  get isGlobalAdmin(): boolean {
    return !!(this.$store.state.currentUser as User | null)?.isGlobalAdmin;
  }

  get apps() {
    return [
      {
        value: "DISA Gestores",
        text: "DISA Gestores"
      },
      {
        value: "DISA Gas",
        text: "DISA Gas"
      }
    ];
  }

  async created() {
    this.loading = true;
    await queryManagementData()
      .then((m) => {
        this.managementData = m;
        this.loading = false;
      })
      .catch((e) => {
        this.error = e.message;
        this.loading = false;
      });
    await this.refreshTerminals();
  }

  async refreshTerminals() {
    try {
      const terminals = await queryDisaDebugTerminals();
      this.debugTerminals = terminals;
      this.loadingTerminals = false;
    } catch (e) {
      this.loadingTerminals = false;
      console.log(e);
    }
  }

  get disableSave() {
    const t = this.editedItem;
    if (!t.app || !t.id || !t.name) return true;
    return false;
  }

  get tableHeaders() {
    return [
      {
        text: "MAC",
        align: "start",
        value: "id"
      },
      {
        text: this.lang.name,
        align: "start",
        value: "name"
      },
      {
        text: "App",
        align: "start",
        value: "app"
      },
      {
        text: "Actions",
        value: "actions",
        class: "text-end",
        sortable: false
      }
    ];
  }

  cmdNewItem() {
    this.dialog = true;
  }
  close() {
    this.dialog = false;
    this.isEditForm = false;
    this.editedItem = {
      id: "",
      name: "",
      app: ""
    };
  }
  editItem(item?: DebugTerminal) {
    if (item) {
      this.isEditForm = true;
      this.editedItem = {
        id: item.id,
        name: item.name,
        app: item.app
      };
    }
    this.dialog = true;
  }
  deleteItem(item: DebugTerminal) {
    this.deleteDialog = true;
    this.itemToDelete = item;
  }

  // SAVE
  async cmdSave() {
    const params: ParamsDebugTerminal = {
      ...this.editedItem,
      action: "save"
    };
    params.id.toLowerCase();
    await saveDisaDebugTerminals(params);
    this.dialog = false;
    this.refreshTerminals();
  }

  // DELETE
  async cmdDelete() {
    if (this.itemToDelete) {
      const params: ParamsDebugTerminal = {
        ...this.itemToDelete,
        action: "delete"
      };
      await saveDisaDebugTerminals(params);
    }
    this.deleteDialog = false;
    this.itemToDelete = null;
    this.refreshTerminals();
  }

  async cmdExportUserAudit() {
    await callExportAuditLogins({
      from: this.exportUserAudit.from,
      to: this.exportUserAudit.to,
      limit: this.exportUserAudit.limit,
      uid: this.exportUserAudit.uid
    });
  }

  async cmdExportVending() {
    await callExportVending(this.exportVending.tcod);
  }
  async cmdExportTransactions() {
    await callExportTransactions({
      from: this.exportTransaction.from,
      to: this.exportTransaction.to,
      limit: this.exportTransaction.limit,
      companyID: this.exportTransaction.companyID
    });
  }
}
